import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearSession } from '../../login/page';

export default function DashboardHeader() {
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const username = localStorage.getItem('username') || 'User';
  const userId = localStorage.getItem('userId') || '';

  const handleLogout = () => {
    clearSession();
    navigate('/login');
  };

  return (
    <header className="bg-white border-b border-gray-200 px-8 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <h1 className="text-xl font-semibold text-gray-900">Sparsh Intranet</h1>
        </div>

        <div className="flex items-center gap-6">
          <button className="relative p-2 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">
            <i className="ri-notification-line text-xl text-gray-600 w-5 h-5 flex items-center justify-center"></i>
            <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
          </button>

          <div className="relative">
            <button
              onClick={() => setShowUserMenu(!showUserMenu)}
              className="flex items-center gap-3 p-2 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center">
                <span className="text-white text-sm font-semibold">{username.charAt(0).toUpperCase()}</span>
              </div>
              <div className="flex flex-col items-start">
                <span className="text-sm font-medium text-gray-700">{username}</span>
                {userId && <span className="text-xs text-gray-500">@{userId}</span>}
              </div>
              <i className="ri-arrow-down-s-line text-gray-600 w-4 h-4 flex items-center justify-center"></i>
            </button>

            {showUserMenu && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                <button
                  onClick={() => navigate('/profile')}
                  className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 cursor-pointer whitespace-nowrap flex items-center gap-2"
                >
                  <i className="ri-user-line w-4 h-4 flex items-center justify-center"></i>
                  Profile
                </button>
                <button
                  onClick={handleLogout}
                  className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-gray-100 cursor-pointer whitespace-nowrap flex items-center gap-2"
                >
                  <i className="ri-logout-box-line w-4 h-4 flex items-center justify-center"></i>
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
